import { Link } from 'react-router-dom'

import { PageHeader } from '@/components/ui/PageHeader'
import { NoticePromotionSummaryCards } from '@/components/venue/NoticePromotionSummaryCards'
import { useCampaignSummary } from '@/hooks/useCampaignSummary'
import { todayDateKey } from '@/lib/venue/calendarGrid'
import { defaultCampaignSummaryPeriod } from '@/lib/venue/campaignViewModel'
import { useVenueContext } from '@/routes/venueContext'

/**
 * 공지·홍보 관리 홈 — 'notices'(설계 §2). 운영 공지·지역 홍보 요약 카드 2장 + 이력 전체보기 진입.
 * 🚨 이 화면은 조립만 한다. 요약 집계·문구는 `campaignViewModel.ts`/`NoticePromotionSummaryCards`가 소유한다.
 */
export function VenueNoticesHomePage() {
  const { venueId } = useVenueContext()
  const period = defaultCampaignSummaryPeriod(todayDateKey())

  const noticeSummaryQuery = useCampaignSummary(venueId, { ...period, type: 'NOTICE' })
  const promotionSummaryQuery = useCampaignSummary(venueId, { ...period, type: 'PROMOTION' })

  return (
    <>
      <PageHeader
        title="공지·홍보 관리"
        description={
          <span className="flex flex-wrap gap-x-4">
            <Link to={`/venues/${venueId}/notices/history`} className="text-brand-500 underline">
              발송 이력 전체보기
            </Link>
            <Link to={`/venues/${venueId}/notices/performance`} className="text-brand-500 underline">
              홍보 성과·비용 조회
            </Link>
          </span>
        }
      />

      <NoticePromotionSummaryCards
        venueId={venueId}
        notice={noticeSummaryQuery.data}
        noticeLoading={noticeSummaryQuery.isLoading}
        promotion={promotionSummaryQuery.data}
        promotionLoading={promotionSummaryQuery.isLoading}
      />
    </>
  )
}
